"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildClerkProps = exports.getAuth = exports.createGetAuth = void 0;
const backend_1 = require("@clerk/backend");
const debugLogger_1 = require("../utils/debugLogger");
const clerkClient_1 = require("./clerkClient");
const errors_1 = require("./errors");
const utils_1 = require("./utils");
const createGetAuth = ({ debugLoggerName, noAuthStatusMessage, }) => (0, debugLogger_1.withLogger)(debugLoggerName, logger => {
    return (req, opts) => {
        const debug = (0, utils_1.getHeader)(req, backend_1.constants.Headers.EnableDebug) === 'true';
        if (debug) {
            logger.enable();
        }
        // When the auth status is set, we trust that the middleware has already run
        // Then, we don't have to re-verify the JWT here,
        // we can just strip out the claims manually.
        const authStatus = (0, utils_1.getAuthKeyFromRequest)(req, 'AuthStatus');
        const authMessage = (0, utils_1.getAuthKeyFromRequest)(req, 'AuthMessage');
        const authReason = (0, utils_1.getAuthKeyFromRequest)(req, 'AuthReason');
        logger.debug('Headers debug', { authStatus, authMessage, authReason });
        if (!authStatus) {
            throw new Error(noAuthStatusMessage);
        }
        const options = {
            apiKey: opts?.apiKey || clerkClient_1.API_KEY,
            secretKey: opts?.secretKey || clerkClient_1.SECRET_KEY,
            apiUrl: clerkClient_1.API_URL,
            apiVersion: clerkClient_1.API_VERSION,
            authStatus,
            authMessage,
            authReason,
        };
        logger.debug('Options debug', options);
        if (authStatus !== backend_1.AuthStatus.SignedIn) {
            return (0, backend_1.signedOutAuthObject)(options);
        }
        const jwt = parseJwt(req);
        logger.debug('JWT debug', jwt.raw.text);
        return (0, backend_1.signedInAuthObject)(jwt.payload, { ...options, token: jwt.raw.text });
    };
});
exports.createGetAuth = createGetAuth;
exports.getAuth = (0, exports.createGetAuth)({
    debugLoggerName: 'getAuth()',
    noAuthStatusMessage: (0, errors_1.getAuthAuthHeaderMissing)(),
});
const buildClerkProps = (req, initState = {}) => {
    const authStatus = (0, utils_1.getAuthKeyFromRequest)(req, 'AuthStatus');
    const authMessage = (0, utils_1.getAuthKeyFromRequest)(req, 'AuthMessage');
    const authReason = (0, utils_1.getAuthKeyFromRequest)(req, 'AuthReason');
    const options = {
        apiKey: clerkClient_1.API_KEY,
        secretKey: clerkClient_1.SECRET_KEY,
        apiUrl: clerkClient_1.API_URL,
        apiVersion: clerkClient_1.API_VERSION,
        authStatus,
        authMessage,
        authReason,
    };
    let authObject;
    if (!authStatus || authStatus !== backend_1.AuthStatus.SignedIn) {
        authObject = (0, backend_1.signedOutAuthObject)(options);
    }
    else {
        const { payload, raw } = parseJwt(req);
        authObject = (0, backend_1.signedInAuthObject)(payload, { ...options, token: raw.text });
    }
    const sanitizedAuthObject = (0, backend_1.makeAuthObjectSerializable)((0, backend_1.sanitizeAuthObject)({ ...authObject, ...initState }));
    return (0, utils_1.injectSSRStateIntoObject)({}, sanitizedAuthObject);
};
exports.buildClerkProps = buildClerkProps;
const parseJwt = (req) => {
    const cookieToken = (0, utils_1.getCookie)(req, backend_1.constants.Cookies.Session);
    const headerToken = (0, utils_1.getHeader)(req, 'authorization')?.replace('Bearer ', '');
    return (0, backend_1.decodeJwt)(cookieToken || headerToken || '');
};
